export default __webpack_public_path__ + "static/media/3.67c9f82e.png";